import { DialogProps, Root } from '@radix-ui/react-dialog';

export type SheetProps = DialogProps;

export const Sheet = Root;
